import styled from "styled-components"
import PropTypes from "prop-types"
import {
  fontSize,
  space,
  color,
  fontWeight,
  width,
  flex,
  responsiveStyle
} from "styled-system"
import { fontSizeProps } from "../../utils/styled-system-props"

const lineHeight = responsiveStyle({
  prop: "lineHeight",
  cssProperty: "line-height"
})

const alignText = responsiveStyle({
  prop: "alignText",
  cssProperty: "text-align"
})

const Text = styled.div`
  font-family: ${props => props.fontFamily}, sans-serif;
  ${flex};
  ${fontSize};
  ${alignText};
  ${lineHeight};
  ${space};
  ${color};
  ${fontWeight};
  ${width};
`

Text.defaultProps = {
  fontFamily: "futura-pt"
}

Text.propTypes = {
  ...fontSizeProps,
  fontFamily: PropTypes.oneOf(["futura-pt", "adobe-garamond-pro", "Libre Baskerville"])
}

export default Text



// WEBPACK FOOTER //
// ./src/components/text/text.component.js